module.exports = __webpack_public_path__ + "img/hbg.96d40712.png";